import React, { Fragment } from "react";
import "../Washup.css";
// import "../assets/css/Responsive.css";

const WashupTheme = () => (<Fragment></Fragment>);

export default WashupTheme;
